module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v("Vozači")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button button-outline",
    staticStyle: {
      "background": "#2b542c",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.openAddUserModal()
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" Dodaj vozača\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "input",
    staticStyle: {
      "width": "90%",
      "border-radius": "10px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Pretraga",
      "name": "users"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onlyActives),
      expression: "onlyActives"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox",
      "name": "users"
    },
    domProps: {
      "checked": Array.isArray(_vm.onlyActives) ? _vm._i(_vm.onlyActives, null) > -1 : (_vm.onlyActives)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.onlyActives,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.onlyActives = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.onlyActives = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.onlyActives = $$c
        }
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v("\n                    \n                "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onlyArchived),
      expression: "onlyArchived"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox1",
      "name": "users"
    },
    domProps: {
      "checked": Array.isArray(_vm.onlyArchived) ? _vm._i(_vm.onlyArchived, null) > -1 : (_vm.onlyArchived)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.onlyArchived,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.onlyArchived = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.onlyArchived = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.onlyArchived = $$c
        }
      }
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.allRates()
      }
    }
  }, [_c('u', [_vm._v("Pogledaj sve ocene")])])]), _vm._v(" "), _c('br'), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed",
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "40px",
      "color": "white"
    }
  }, [_vm._v("R. br")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "100px",
      "color": "white"
    }
  }, [_vm._v("Slika")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Ime")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Nadimak")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Username")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Telefon")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "150px",
      "color": "white"
    }
  }, [_vm._v("Start")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Ocena")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "150px",
      "color": "white"
    }
  }, [_vm._v("Slobodni dani")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "150px",
      "color": "white"
    }
  }, [_vm._v("Deaktiviraj")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "150px",
      "color": "white"
    }
  }, [_vm._v("Izmeni")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "150px",
      "color": "white"
    }
  }, [_vm._v("Arhiva")]), _vm._v(" "), (_vm.visibleDevelop()) ? _c('th', {
    staticStyle: {
      "width": "150px",
      "color": "white"
    }
  }, [_vm._v("Obriši")]) : _vm._e()])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredUsers), function(user, index) {
    return _c('tr', {
      staticStyle: {
        "color": "white",
        "background-color": "#4E5066 !important"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm.filteredUsers.length - index) + ".")]), _vm._v(" "), (user.profileImageUrl != null) ? _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_c('img', {
      staticClass: "cropped1",
      attrs: {
        "src": _vm.getDriverImage(user),
        "width": "50px",
        "height": "50px"
      }
    })]) : _vm._e(), _vm._v(" "), (user.profileImageUrl == null) ? _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_c('img', {
      staticClass: "cropped1-missing",
      attrs: {
        "src": require("../../assets/img/missingImage.png"),
        "width": "50px",
        "height": "50px"
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(user.firstName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(user.lastName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(user.phoneNumber))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(user.displayStatus) + "  "), (user.viberId != null) ? _c('img', {
      staticStyle: {
        "width": "20px",
        "height": "20px"
      },
      attrs: {
        "src": require("../../assets/img/ic_viber.png")
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px"
      }
    }, [_vm._v(_vm._s(user.startTime) + " "), _c('button', {
      staticClass: "button-small button-outline",
      staticStyle: {
        "background": "#843534"
      },
      on: {
        "click": function($event) {
          return _vm.openCourierStartTime(user)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    })])]), _vm._v(" "), _c('td', [_vm._l((_vm.getRate(user)), function(rate) {
      return _c('span', [_c('i', {
        staticClass: "ti-star",
        style: (_vm.getRateStyle(rate))
      })])
    }), _vm._v("\n                              \n                            "), _c('span', {
      staticStyle: {
        "color": "white"
      }
    }, [_c('b', [_vm._v(_vm._s(user.averageRate != null ? user.averageRate.toFixed(1) : '0.0'))])]), _vm._v("\n                              \n                            "), _c('span', {
      staticStyle: {
        "color": "cornflowerblue",
        "cursor": "pointer"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.openRate(user)
        }
      }
    }, [_vm._m(2, true)])])], 2), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_c('button', {
      staticClass: "button-small button-outline",
      staticStyle: {
        "background": "#843534"
      },
      on: {
        "click": function($event) {
          return _vm.openEditFreeDays(user)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    })]), _vm._v(_vm._s(user.freeDays))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [(user.active) ? _c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "#946d13"
      },
      attrs: {
        "type": "button",
        "placeholder": "Deaktiviraj",
        "name": "Deaktiviraj",
        "value": "Deaktiviraj"
      },
      on: {
        "click": function($event) {
          return _vm.deactivateDriver(user)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "cornflowerblue"
      },
      attrs: {
        "type": "button",
        "placeholder": "Izmeni",
        "name": "Obriši",
        "value": "Izmeni"
      },
      on: {
        "click": function($event) {
          return _vm.editDriver(user)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "#843534"
      },
      attrs: {
        "type": "button",
        "value": user.archived ? 'Povrati' : 'Arhiviraj'
      },
      on: {
        "click": function($event) {
          return _vm.archiveDriver(user, !user.archived)
        }
      }
    })]), _vm._v(" "), (_vm.visibleDevelop()) ? _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "#843534"
      },
      attrs: {
        "type": "button",
        "placeholder": "Obriši",
        "name": "Obriši",
        "value": "Obriši"
      },
      on: {
        "click": function($event) {
          return _vm.deleteDriver(user)
        }
      }
    })]) : _vm._e()])
  }), 0)])])])]), _vm._v(" "), _c('add-user-modal', {
    attrs: {
      "show": _vm.openAddOrder,
      "driver": _vm.driverToEdit
    }
  }), _vm._v(" "), _c('add-free-days-modal', {
    attrs: {
      "show": _vm.openFreeDays,
      "courier": _vm.openFreeDaysObject
    }
  }), _vm._v(" "), _c('change-courier-start-time', {
    attrs: {
      "show": _vm.changeCourierStart,
      "driver": _vm.courierTime
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('label', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "for": "checkbox"
    }
  }, [_vm._v("Prikaži samo aktivne")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('label', {
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "for": "checkbox1"
    }
  }, [_vm._v("Prikaži samo arhivirane")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('u', [_vm._v("pogledaj sve ocene")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0114ce08!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Drivers/Drivers.vue
// module id = 448
// module chunks = 1